"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var r = exports, e = {
    get createActions () {
        return f;
    },
    get createDataFieldsReactions () {
        return u;
    }
};
for(var t in e)Object.defineProperty(r, t, {
    enumerable: !0,
    get: Object.getOwnPropertyDescriptor(e, t).get
});
var n = require("mobx-miniprogram");
function o(r, e) {
    (null == e || e > r.length) && (e = r.length);
    for(var t = 0, n = Array(e); t < e; t++)n[t] = r[t];
    return n;
}
function i(r, e, t) {
    return e in r ? Object.defineProperty(r, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : r[e] = t, r;
}
function a(r) {
    return function(r) {
        if (Array.isArray(r)) return o(r);
    }(r) || function(r) {
        if ("u" > typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }(r) || function(r) {
        if (r) {
            if ("string" == typeof r) return o(r, void 0);
            var e = Object.prototype.toString.call(r).slice(8, -1);
            if ("Object" === e && r.constructor && (e = r.constructor.name), "Map" === e || "Set" === e) return Array.from(e);
            if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return o(r, void 0);
        }
    }(r) || function() {
        throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function c(r) {
    return r && "u" > typeof Symbol && r.constructor === Symbol ? "symbol" : typeof r;
}
var f = function(r, e) {
    var t = e.store, n = e.actions;
    if (n) {
        if (void 0 === t) throw Error('[mobx-miniprogram] no store specified');
        Array.isArray(n) ? n.forEach(function(e) {
            if (r[e]) throw Error('[mobx-miniprogram] multiple action definition');
            r[e] = function() {
                for(var r = arguments.length, n = Array(r), o = 0; o < r; o++)n[o] = arguments[o];
                return t[e].apply(t, a(n));
            };
        }) : (void 0 === n ? "undefined" : c(n)) === 'object' && Object.keys(n).forEach(function(e) {
            var o = n[e];
            if ('string' != typeof e && 'number' != typeof e) throw Error('[mobx-miniprogram] unrecognized field definition');
            r[e] = function() {
                for(var r = arguments.length, e = Array(r), n = 0; n < r; n++)e[n] = arguments[n];
                return t[o].apply(t, a(e));
            };
        });
    }
}, u = function(r, e) {
    var t = e.store, o = e.fields, a = e.structuralComparison, f = e.namespace || '';
    if (f && 'string' != typeof f) throw Error('[mobx-miniprogram] namespace only expect string');
    var u = Object.assign({}, r[f = f.replace(/ /gm, '')]), s = a ? n.comparer.structural : void 0, l = null, p = function() {
        if (null !== l) {
            var e = l;
            l = null, r.setData(e);
        }
    }, m = function(r, e) {
        if (l || (l = {}, "u" > typeof wx ? wx.nextTick(p) : Promise.resolve().then(p)), '' !== f) {
            var t, o;
            t = function(r) {
                for(var e = 1; e < arguments.length; e++){
                    var t = null != arguments[e] ? arguments[e] : {}, n = Object.keys(t);
                    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(r) {
                        return Object.getOwnPropertyDescriptor(t, r).enumerable;
                    }))), n.forEach(function(e) {
                        i(r, e, t[e]);
                    });
                }
                return r;
            }({}, u), o = null != (o = i({}, r, (0, n.toJS)(e))) ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(o)) : (function(r) {
                var e = Object.keys(r);
                if (Object.getOwnPropertySymbols) {
                    var t = Object.getOwnPropertySymbols(r);
                    e.push.apply(e, t);
                }
                return e;
            })(Object(o)).forEach(function(r) {
                Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(o, r));
            }), u = t, l[f] = u;
        } else l[r] = (0, n.toJS)(e);
    }, y = [];
    if (Array.isArray(o)) {
        if (void 0 === t) throw Error('[mobx-miniprogram] no store specified');
        y = o.map(function(r) {
            return (0, n.reaction)(function() {
                return t[r];
            }, function(e) {
                m(r, e);
            }, {
                equals: s,
                fireImmediately: !0
            });
        });
    } else (void 0 === o ? "undefined" : c(o)) === 'object' && o && (y = Object.keys(o).map(function(e) {
        var i = o[e];
        if ('function' == typeof i) return (0, n.reaction)(function() {
            return i.call(r, t);
        }, function(r) {
            m(e, r);
        }, {
            equals: s,
            fireImmediately: !0
        });
        if ('string' != typeof e && 'number' != typeof e) throw Error('[mobx-miniprogram] unrecognized field definition');
        if (void 0 === t) throw Error('[mobx-miniprogram] no store specified');
        return (0, n.reaction)(function() {
            return t[i];
        }, function(r) {
            m(String(e), r);
        }, {
            equals: s,
            fireImmediately: !0
        });
    }));
    return {
        updateStoreBindings: p,
        destroyStoreBindings: function() {
            y.forEach(function(r) {
                r();
            });
        }
    };
};
